<template>
  <div
    id="thank-you-wrapper"
    class="py-10 px-10 border border-default rounded mb-10 text-center shadow-lift"
  >
    <h1 class="text-center mb-0">Thank you for your support</h1>
  </div>
</template>
<script>
export default {
  components: {},
  props: {},
  data() {
    return { allocationFinished: false, allocation: "" };
  },
  mounted() {},
  methods: {
    allocate() {
      let self = this;
      const urlParams = new URLSearchParams(window.location.search);
      let tx = urlParams.get("tx");
      this.axios
        .post(window.API_URL + "allocate", {
          id: tx,
          allocation: this.allocation,
        })
        .then(function (response) {
          self.allocationFinished = true;
        })
        .catch(function (error) {});
    },
  },
};
</script>
<style lang="scss">
#thank-you-wrapper.rounded {
  border-radius: 30px !important;
  background: rgba(255, 255, 255, 0.5);
}
</style>